import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { FoleonIcon, IconType } from "../icons/Icons";
import Bookmark from "./Bookmark";

type DocumentCardProps = {
    publicationName: string;
	publicationId : number;
	publicationTotalPages: number;
};

export const DocumentCard = ({ publicationName, publicationId, 
	publicationTotalPages }: DocumentCardProps) => {
	return (
		<>
			<Flex
				direction="column"
				alignItems="center"
				gap="15px"
				textColor="grey"
			>
				<Flex
					direction="column"
					border="1px solid black"
					alignItems="center"
					minW="312px"
					maxW="312px"
					minH="214px"
					maxH="214px"
					gap="15px"
					boxShadow="rgba(0, 0, 0, 0.07) 0px 1px 8px 0px"
					_hover={{ transform: "translateY(-10px)",
						boxShadow: "rgb(0 0 0 / 35%) 0px 40px 44px -30px" }}
					transition={"ease-in-out 200ms"}
					transitionProperty={"transform, box-shadow"}
					position="relative"
				>
					<Bookmark 
						publicationId={publicationId}
						publicationTotalPages={publicationTotalPages}
					/>
					<Box
						marginTop="4px"
						minW="302px"
						maxW="302px"
						minH="156px"
						maxH="156px"
						textAlign="center"
						cursor="pointer"
						backgroundImage={"./tempDocPicture.jpeg"}
					>

					</Box>
					<Flex
						gap="80px"
						alignItems="center"
						justifyContent="around"
					>
						<FoleonIcon iconType={IconType.ONLINE_STATUS}/>

						<Flex className="crud-options"
							gap="15px"
						>
							<FoleonIcon iconType={IconType.EYE_ICON}/>
							<FoleonIcon iconType={IconType.PEN}/>
						</Flex>


						<FoleonIcon iconType={IconType.HAMBURGER_MENU}/>
					</Flex>
				</Flex>
				<Text>{publicationName}</Text>
			</Flex>
		</>
	);
};

export default DocumentCard;